module.exports = __webpack_public_path__ + "img/not_found_statement.8e5418b1.svg";